import React from 'react';
import { Dialog, DialogTitle, DialogContent, Typography } from '@mui/material';
import { styled } from '@mui/system';
import Button from '../../../PublicSide/components/Button/Button';
import { StyledBox, StyledButtonCancelSubmit } from '../../../style/GlobalsComponentsStyled';

const StyledDialog = styled(Dialog)({
  '& .MuiPaper-root': {
    backgroundColor: '#1C1D2B',
    borderRadius: '10px',
    padding: '1.5rem',
    width: '500px',
    maxWidth: '90%',
    color: 'white',
    marginLeft: '212px',
  },
});

interface DeleteConfirmationDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const DeleteConfirmationDialog: React.FC<DeleteConfirmationDialogProps> = ({ open, onClose, onConfirm }) => {
  return (
    <StyledDialog open={open} onClose={onClose}>
      <StyledBox>
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          <Typography marginBottom={'2.5rem'}>
            Are you sure you want to delete this?
          </Typography>
          <StyledButtonCancelSubmit >
            <Button text='Cancel' onClick={onClose} />
            <Button text='Confirm' onClick={onConfirm} />
          </StyledButtonCancelSubmit>
        </DialogContent>
      </StyledBox>
    </StyledDialog>
  );
};

export default DeleteConfirmationDialog;
